import React, { useEffect, Fragment } from "react";
import { withRouter } from "react-router-dom";
import AppHeader from "./_header";
import AppFooter from "./_footer";

function Container({ ...props }) {
  const { history, children, name, hideFooter = false, hideHeader = false} = props;
  useEffect(() => {
    const unlisten = history.listen(() => {});
    return () => {
      unlisten();
    };
  }, []);
  if (!window.isMobileDevice) {
    return (
      <React.Fragment>
        {name !== "openMarket" && !hideHeader && <AppHeader route={name} />}
        {children}
        {!hideFooter && <AppFooter />}
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {!hideHeader && <AppHeader route={name} />}
        {children}
        {!hideFooter && <AppFooter />}
      </React.Fragment>
    );
  }
}

export default withRouter(Container);
